import { createNoParamsFetcher } from '../contexts/Fetcher';
import { apiProductTool } from '../resources/api/apiProductTool';

const { useGetProductTools } = apiProductTool;

export const ProductToolsFetcher = createNoParamsFetcher(() => useGetProductTools().execute);
